import {
  ApexStroke,
  ChartComponent,
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart,
  ApexGrid,
  ApexPlotOptions,
  ApexAxisChartSeries,
  ApexXAxis,
  ApexDataLabels,
  ApexYAxis,
  ApexTitleSubtitle,
  ApexLegend,
  ApexTheme,
  ApexFill,
  ApexTooltip,
} from 'ng-apexcharts';

export type ChartOptions = {
  series?: ApexAxisChartSeries | ApexNonAxisChartSeries;
  chart?: ApexChart | Partial<ApexChart>;
  xaxis?: ApexXAxis;
  stroke?: ApexStroke;
  dataLabels?: ApexDataLabels;
  responsive?: ApexResponsive[];
  yaxis?: ApexYAxis;
  title?: ApexTitleSubtitle;
  labels?: string[];
  legend?: ApexLegend;
  subtitle?: ApexTitleSubtitle;
  theme?: ApexTheme;
  plotOptions: ApexPlotOptions;
  fill?: ApexFill;
  grid?: ApexGrid;
  tooltip?: ApexTooltip;
  colors?: string[];
};

export const DefaultFontStyle =
  'Roboto, "Helvetica Neue", Helvetica, sans-serif, Arial';

export const DEFAULT_APEX_CHART: Partial<ApexChart> = {
  foreColor: '#fff',
  background: '0',
  fontFamily: DefaultFontStyle,
  toolbar: {
    show: false,
  },
};

export const DEFAULT_LABEL_STYLE = {
  fontSize: '10px',
};

export const DEFAULT_APEX_OPTIONS: Partial<ChartOptions> = {
  theme: {
    mode: 'dark',
  },
  grid: {
    padding: {
      left: -5,
      right: 5,
    },
  },
  chart: {
    ...DEFAULT_APEX_CHART,
  },
};

export const DEFAULT_DONUT_OPTIONS: Partial<ApexPlotOptions> = {
  pie: {
    donut: {
      size: '75%',
      labels: {
        show: true,
        total: {
          color: '#fff',
          show: true,
          formatter: function (w) {
            let result = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
            return `${Math.round(result * 100) / 100}`; // * 100 for 2 decimal numbers
          },
        },
        value: {
          offsetY: -4,
        },
      },
    },
    expandOnClick: false,
  },
};

export type DashboardChartInput = {
  values?: ApexAxisChartSeries | ApexNonAxisChartSeries;
  labels?: string[];
  title?: ApexTitleSubtitle;
  colors?: string[];
  height?: string | number;
  width?: string | number;
  xaxis?: ApexXAxis;
  yaxis?: ApexYAxis;
  dataLabels?: ApexDataLabels;
  chart?: ApexChart | Partial<ApexChart>;
  tooltip?: ApexTooltip | Partial<ApexTooltip>;
  plotOptions?: ApexPlotOptions | Partial<ApexPlotOptions>;
};
